<template lang="pug">
  include ../../../../../pug/mixins/bem
  div
    +b.poll-title--centered.H1 {{ _('Вашу заявку відправлено в обробку') }}
    +b.poll-text.P {{ _("Наш спеціаліст найближчим часом надішле Вам посилку, або зв'яжеться з Вами для уточнень.") }}

</template>

<script>
export default {
  name: 'Success',
  data() {
    return {

    }
  },
  mounted() {
    this.next()
  },
  methods: {
    next() {
      let obj = {
        current: '',
        finish: true,
      }
      this.$emit('next', obj)
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/js/shared/components/poll/steps/success.vue